export default ['anticonstitutionnellement', 'oto-rhino-laryngologistes'];
